import { render, staticRenderFns } from "./ColonyCreate.vue?vue&type=template&id=33c8e2b2&scoped=true&"
import script from "./ColonyCreate.vue?vue&type=script&lang=js&"
export * from "./ColonyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c8e2b2",
  null
  
)

export default component.exports